@if (label) {
  <label class="ppl-label">{{ label }}</label>
}
<ng-content></ng-content>
